/* eslint-disable */
const internals = {
  $formGroup: '.form-group',
  $hsFormField: '.hs-form-field',

  validateMail($elm, selfClass, selfVal) {
    if (selfClass.indexOf('require-email') !== -1) {
      const filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/
      const filterFreeMail = /^([\w.-]+)@(\[(\d{1,3}\.){3}|(?!gmail|yahoo|gotmail|hotmail|aol|email|live|icloud|gmx|yandex|mail|lycos|protonmail|tutanota|zoho|outlook|msn|mac|comcast|test|mailinator|ymail|verizon|att|hotmail|hotmail|yahoo|googlemail|bellsouth|jumo|gmx|rediffmail|orange|t\-online|web\.|online\.|live\.)(([a-zA-Z\d-]+\.)+))([a-zA-Z]{2,4}|\d{1,3})(\]?)$/
      if (!filter.test(selfVal) || (selfVal.indexOf('.') === -1)) {
        $elm.addClass('error')
        $elm.parents(this.$formGroup).addClass('err-email')
      } else {
        $elm.removeClass('error')
        $elm.parents(this.$formGroup).removeClass('err-email')
      }
      if (!filterFreeMail.test(selfVal)) {
        $elm.addClass('error is-free-mail')
        $elm.parents(this.$formGroup).addClass('err-email is-free-mail')
      } else {
        $elm.removeClass('error is-free-mail')
        $elm.parents(this.$formGroup).removeClass('err-email is-free-mail')
      }
    }
  },
  validateSelect($elm, selfVal) {
    if (selfVal === '') {
      $elm.parent().find('a.dropdown-toggle').addClass('error')
    } else {
      $elm.parent().find('a.dropdown-toggle').removeClass('error')
    }
  },
  validateInput(e) {
    const $elm = $(e)
    const selfClass = $elm.attr('class')
    const selfVal = $elm.val()
    const isDropdown = $elm.prop('nodeName') === 'SELECT'
    if (selfClass !== undefined) {
      if (selfClass.indexOf('require') > -1) {
        if (isDropdown) {
          this.validateSelect($elm, selfVal)
        }
        if (selfVal === '') {
          $elm.addClass('error')
        } else {
          $elm.removeClass('error')
        }
      }
      this.validateMail($elm, selfClass, selfVal)
    }
  },
  validateFormField($object) {
    const me = this
    $object.find('input,select').each((_i, e) => {
      me.validateInput(e)
    })
  },
  validateActionForm($form, $btSubmit) {
    const me = this
    $form.find('input').keyup((e) => {
      let k
      if (e.charCode) {
        k = e.charCode
      } else if (e.keyCode) {
        k = e.keyCode
      } else {
        k = 0
      }
      if (k === 9) {
        return
      } else if (k === 13) {
        $btSubmit.trigger('click')
        $(e.currentTarget).focus()
        return
      }
      else {
        const isCheckValidate = $btSubmit.data('isCheckValidate')
        if (isCheckValidate === true) {
          if ($form.hasClass('hs-form')) {
            me.validateInputHubspot(e.currentTarget)
          }
          else {
            me.validateInput(e.currentTarget)
          }
        }
        return
      }
    })
  },
  validateMailHuspot($elm, selfVal) {
    const filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/
    const $errors = $elm.parent('.input').next('.hs-error-msgs').find('.hs-error-msg')
    const $form = $elm.parents('.hs-form')
    const freeMailMsg = '.free-mail-msg';
    if (!filter.test(selfVal) || (selfVal.indexOf('.') === -1) || $errors.length) {
      $elm.addClass('error')
      $elm.parents(this.$hsFormField).addClass('wrap-val')
      $errors.each((_i, ele) => {
        if ($(freeMailMsg).length) {
          $(freeMailMsg).remove()
        }
        if ($(ele).text().includes('business email address')) {
          $form.append(`<div class="free-mail-msg">${$(ele).text()}</div>`);
        }
      })
    } else {
      $elm.removeClass('error')
      $elm.parents(this.$hsFormField).removeClass('wrap-val')
      if ($(freeMailMsg).length) {
        $(freeMailMsg).remove()
      }
    }
  },
  validateInputHubspot(e) {
    const $elm = $(e)
    const selfVal = $elm.val()
    if (selfVal === '') {
      $elm.addClass('error')
      $elm.parents(this.$hsFormField).addClass('wrap-val')
    } else {
      $elm.removeClass('error')
      $elm.parents(this.$hsFormField).removeClass('wrap-val')
    }
    if ($elm.parent().parent().hasClass('hs_email')) {
      this.validateMailHuspot($elm, selfVal)
    }
  },
  validateFormFieldHubspot($object) {
    const me = this
    $object.find('.hs-input,input.require').each((_i, e) => {
      me.validateInputHubspot(e)
    })
  },
}

const ValidateForm = (() => {
  // Validate Form
})()

export const validateActionKeyupForm = (form, btSubmit) => {
  internals.validateActionForm(form, btSubmit)
}

export const validateFormFields = (form) => {
  internals.validateFormField(form)
}

export const validateFormFieldsHubspot = (form) => {
  internals.validateFormFieldHubspot(form)
}

export default ValidateForm